// Preferences.js

import React, { useState, useEffect } from "react";

function Preferences() {
  const [cadCashback, setCadCashback] = useState("0");
  const [usdCashback, setUsdCashback] = useState("0");
  const [temperature, setTemperature] = useState("both");
  const [primaryCurrency, setPrimaryCurrency] = useState("CAD");
  const [fuelUnit, setFuelUnit] = useState("litres");
  const [weatherLocation, setWeatherLocation] = useState("Windsor");
  const [usdFxFee, setUsdFxFee] = useState("2.5");
  const [cadFxFee, setCadFxFee] = useState("0");
  const [tankLitres, setTankLitres] = useState("");
  const [tankGallons, setTankGallons] = useState("");

  useEffect(() => {
    const savedCad = localStorage.getItem("cadCashback") || "0";
    const savedUsd = localStorage.getItem("usdCashback") || "0";
    const savedTemp = localStorage.getItem("temperature") || "both";
    const savedPrimary = localStorage.getItem("primaryCurrency") || "CAD";
    const savedFuelUnit = localStorage.getItem("fuelUnit") || "litres";
    const savedWeatherLocation =
      localStorage.getItem("weatherLocation") || "Windsor";
    const savedUsdFxFee = localStorage.getItem("usdFxFee") || "2.5";
    const savedCadFxFee = localStorage.getItem("cadFxFee") || "0";
    const savedLitres = localStorage.getItem("tankLitres") || "";
    const savedGallons = localStorage.getItem("tankGallons") || "";
    setCadCashback(savedCad);
    setUsdCashback(savedUsd);
    setTemperature(savedTemp);
    setPrimaryCurrency(savedPrimary);
    setFuelUnit(savedFuelUnit);
    setWeatherLocation(savedWeatherLocation);
    setUsdFxFee(savedUsdFxFee);
    setCadFxFee(savedCadFxFee);
    setTankLitres(savedLitres);
    setTankGallons(savedGallons);

    if (window.gtag && window.consented)
      window.gtag("event", "page_view", { page: "preferences" });
  }, []);

  const saveCadCashback = (value) => {
    setCadCashback(value);
    localStorage.setItem("cadCashback", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "cad_cashback",
        value: value,
      });
  };

  const saveUsdCashback = (value) => {
    setUsdCashback(value);
    localStorage.setItem("usdCashback", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "usd_cashback",
        value: value,
      });
  };

  const saveUsdFxFee = (value) => {
    setUsdFxFee(value);
    localStorage.setItem("usdFxFee", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "usd_fx_fee",
        value: value,
      });
  };

  const saveCadFxFee = (value) => {
    setCadFxFee(value);
    localStorage.setItem("cadFxFee", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "cad_fx_fee",
        value: value,
      });
  };

  const saveTemperature = (value) => {
    setTemperature(value);
    localStorage.setItem("temperature", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "temperature",
        value: value,
      });
  };

  const savePrimaryCurrency = (value) => {
    setPrimaryCurrency(value);
    localStorage.setItem("primaryCurrency", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "primary_currency",
        value: value,
      });
  };

  const saveFuelUnit = (value) => {
    setFuelUnit(value);
    localStorage.setItem("fuelUnit", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "fuel_unit",
        value: value,
      });
  };

  const saveWeatherLocation = (value) => {
    setWeatherLocation(value);
    localStorage.setItem("weatherLocation", value);
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "weather_location",
        value: value,
      });
  };

  const saveTankLitres = (value) => {
    setTankLitres(value);
    localStorage.setItem("tankLitres", value);
    if (value) {
      const gallons = (parseFloat(value) / 3.78541).toFixed(2);
      setTankGallons(gallons);
      localStorage.setItem("tankGallons", gallons);
    } else {
      setTankGallons("");
      localStorage.setItem("tankGallons", "");
    }
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "tank_litres",
        value: value,
      });
  };

  const saveTankGallons = (value) => {
    setTankGallons(value);
    localStorage.setItem("tankGallons", value);
    if (value) {
      const litres = (parseFloat(value) * 3.78541).toFixed(2);
      setTankLitres(litres);
      localStorage.setItem("tankLitres", litres);
    } else {
      setTankLitres("");
      localStorage.setItem("tankLitres", "");
    }
    if (window.gtag && window.consented)
      window.gtag("event", "preference_changed", {
        preference: "tank_gallons",
        value: value,
      });
  };

  return (
    <section className="utility canada-theme us-theme">
      <h2>Preferences</h2>
      <div className="preference-item">
        <label>Credit Card Settings</label>
        <table className="credit-card-table">
          <thead>
            <tr>
              <th></th>
              <th>CAD</th>
              <th>USD</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Cashback (%)</td>
              <td>
                <input
                  type="number"
                  step="0.01"
                  value={cadCashback}
                  onChange={(e) => saveCadCashback(e.target.value)}
                  placeholder="e.g. 2.5"
                />
              </td>
              <td>
                <input
                  type="number"
                  step="0.01"
                  value={usdCashback}
                  onChange={(e) => saveUsdCashback(e.target.value)}
                  placeholder="e.g. 1.5"
                />
              </td>
            </tr>
            <tr>
              <td>FX Fee (%)</td>
              <td>
                <input
                  type="number"
                  step="0.1"
                  value={cadFxFee}
                  onChange={(e) => saveCadFxFee(e.target.value)}
                  placeholder="e.g. 0"
                />
              </td>
              <td>
                <input
                  type="number"
                  step="0.1"
                  value={usdFxFee}
                  onChange={(e) => saveUsdFxFee(e.target.value)}
                  placeholder="e.g. 2.5"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="preference-item">
        <label>Temperature Display</label>
        <select
          value={temperature}
          onChange={(e) => saveTemperature(e.target.value)}
        >
          <option value="f">Fahrenheit</option>
          <option value="c">Celsius</option>
          <option value="both">Both</option>
        </select>
      </div>
      <div className="preference-item">
        <label>Primary Currency</label>
        <select
          value={primaryCurrency}
          onChange={(e) => savePrimaryCurrency(e.target.value)}
        >
          <option value="CAD">CAD</option>
          <option value="USD">USD</option>
        </select>
      </div>
      <div className="preference-item">
        <label>Fuel Unit</label>
        <select value={fuelUnit} onChange={(e) => saveFuelUnit(e.target.value)}>
          <option value="litres">Litres</option>
          <option value="gallons">Gallons</option>
        </select>
      </div>
      <div className="preference-item">
        <label>Default Weather Location</label>
        <select
          value={weatherLocation}
          onChange={(e) => saveWeatherLocation(e.target.value)}
        >
          <option value="Windsor">Windsor</option>
          <option value="Detroit">Detroit</option>
        </select>
      </div>
      <div className="preference-item">
        <label>Car Fuel Tank Size</label>
        <div className="tank-inputs">
          <div>
            <input
              type="number"
              step="0.01"
              value={tankLitres}
              onChange={(e) => saveTankLitres(e.target.value)}
              placeholder="Litres"
            />
            <span>L</span>
          </div>
          <div>
            <input
              type="number"
              step="0.01"
              value={tankGallons}
              onChange={(e) => saveTankGallons(e.target.value)}
              placeholder="Gallons"
            />
            <span>gal</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Preferences;
